import { useCallback } from "react";
import { useHistory } from "react-router-dom";

export const useGoBack = defaultUrl => {
    const history = useHistory();

    return useCallback(() => {
        history.length > 2 ? history.goBack() : history.push(defaultUrl);
    }, [history]);
};